import { connectRelevantSort } from 'react-instantsearch-core';
import RelevantSort from "../components/RelevantSort.js";
export default connectRelevantSort(RelevantSort, {
  $$widgetType: 'ais.relevantSort'
});